import styled from 'styled-components';

const Spacer = styled.div`
  margin-bottom: ${(props) => (props.large ? '36px' : '10px')};
`;

export default Spacer;
